module.exports = __webpack_public_path__ + "static/media/12-Rostock@2x.c8ed0d42.jpg";